import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from 'axios';

import "assets/css/custom-css.css";

function StripeGenericPaymentForm(props) {
    const [processing, setProcessing] = useState(false);
    const [success, setSuccess] = useState(false);
    const stripe = useStripe();
    const elements = useElements();
    const [isLightMode, setIsLightMode] = useState(localStorage.getItem("light-mode") === "lightmode");
    const [CARD_OPTIONS, SET_CARD_OPTIONS] = useState({})

    const cardOptions = {
        hidePostalCode: true,
        iconStyle: "solid",
        style: {
            base: {
                iconColor: "#F33B30",
                color: !isLightMode ? "#fff" : "#000",
                fontWeight: 500,
                fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                fontSize: "16px",
                fontSmoothing: "antialiased",
                ":-webkit-autofill": { color: !isLightMode ? "#fff" : "#000" },
                "::placeholder": { color: !isLightMode ? "#fff" : "#000" },
            },
            invalid: {
                iconColor: "#F33B30",
                color: "white"
            }
        }
    }




    useEffect(() => {
        // Listen for changes in the "light-mode" setting in localStorage
        const handleStorageChange = () => {
            setIsLightMode(localStorage.getItem("light-mode") === "lightmode");
        };

        // Add the event listener
        window.addEventListener("lightmodechanged", handleStorageChange);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("lightmodechanged", handleStorageChange);
        };
    }, []);

    useEffect(() => {
        SET_CARD_OPTIONS(cardOptions)
    }, [isLightMode])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setProcessing(true);
        const clientSecret = props.baseObject.paymentClientSecret;
        const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
                //billing_details: {
                //    name: 'Cardholder Name',
                //},
            },
        });

        if (!error) {
            if (!props.isAdSpend) {
                props.renewCredits();
            } else {
                props.handlePurchase();
            }
        } else {
            console.error(error.message);
        }

        setProcessing(false);
    };

    return (
        <>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                <fieldset className="FormGroup stripeCustom stripeMove">
                    <div className="FormRow">
                        <CardElement options={CARD_OPTIONS} />
                    </div>
                </fieldset>
                <div className="d-flex justify-content-center">
                    {processing ?
                        <button className="buttonStyle buttonPrimary mt-4" disabled><Spinner size="sm" /></button>
                        :
                        <button type="submit" className="buttonStyle buttonPrimary mt-4">Pay</button>
                    }

                </div>
            </form>
        </>
    );
}

export default StripeGenericPaymentForm;
